const skipToContentButton = document.querySelector('.skipToContent button')

skipToContentButton.addEventListener('click', () => {
    document.querySelector('input:not([type="hidden"]), select:not([type="hidden"]), main a, main button').focus()
})